import ExpirationDate from '@/models/creditCard/expirationDate';

export default (value: string): boolean => {
  const [month, year] = ExpirationDate.getMonthAndYearFromExpirationDate(value);

  return ExpirationDate.isValid(month, year);
};
